import { render, staticRenderFns } from "./Borrower.vue?vue&type=template&id=59bb578e&scoped=true&"
import script from "./Borrower.vue?vue&type=script&lang=js&"
export * from "./Borrower.vue?vue&type=script&lang=js&"
import style0 from "./Borrower.vue?vue&type=style&index=0&id=59bb578e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bb578e",
  null
  
)

component.options.__file = "Borrower.vue"
export default component.exports